var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCustomerPayment(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Customer_Payment",
    "data-name": "Customer Payment",
    transform: "translate(-79 -228)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Base",
    width: 24,
    height: 24,
    transform: "translate(79 228)",
    fill: "rgba(255,255,255,0.5)",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "file_1_",
    "data-name": "file (1)",
    transform: "translate(81 231)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3226",
    "data-name": "Path 3226",
    d: "M5.746,242a4.746,4.746,0,1,0,4.746,4.746A4.751,4.751,0,0,0,5.746,242Zm2.1,4.17-2.461,2.461a.527.527,0,0,1-.746,0L3.58,247.576a.527.527,0,0,1,.746-.746l.682.682L7.1,245.424a.527.527,0,1,1,.746.746Z",
    transform: "translate(0 -233.492)",
    fill: "rgba(255,255,255,0.5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3227",
    "data-name": "Path 3227",
    d: "M130.668,4.57a.527.527,0,0,1-.527-.527V0h-7.559A1.584,1.584,0,0,0,121,1.582v5.9c.174-.016.35-.024.527-.024A5.792,5.792,0,0,1,126,9.563h5.724a.527.527,0,0,1,0,1.055h-5.029a5.757,5.757,0,0,1,.61,2.109h4.419a.527.527,0,0,1,0,1.055H127.3A5.8,5.8,0,0,1,124.859,18h8.27a1.584,1.584,0,0,0,1.582-1.582V4.57Zm1.055,2.883h-7.734a.527.527,0,0,1,0-1.055h7.734a.527.527,0,0,1,0,1.055Z",
    transform: "translate(-115.781)",
    fill: "rgba(255,255,255,0.5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3228",
    "data-name": "Path 3228",
    d: "M411,8.783V11.99h3.207Z",
    transform: "translate(-395.586 -8.474)",
    fill: "rgba(255,255,255,0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomerPayment);
export default __webpack_public_path__ + "static/media/customerPayment.80815ecf9492b46d1bcba30445d1fbee.svg";
export { ForwardRef as ReactComponent };